export const itemsValidationList = [
  'sku',
  'name',
  'category',
  'unit',
  'trackingMode',
  'costingMethod',
  'expiryPolicy',
]
